<template>
    <div>
        <card-header icon="fa-subtitles-slash">
            <template #title>
                Recent Failed Transactions
            </template>
        </card-header>

        <card-body>
            <card-list>
                <plan-transaction-tile
                    :transaction="t"
                    :card="card"
                    v-for="t in transactions"
                    @click="$openCard('payment-plan', {planId: t.plan_id}, card)"
                />
            </card-list>
        </card-body>

        <card-footer>
            {{ transactions.length }} failed transactions
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardFooter from "@/TIER/components/CardFooter";
    import PlanTransactionTile from "../../components/tiles/PlanTransactionTile";

    import {client as http} from '@/http_client';

    export default {
        components: {PlanTransactionTile, CardFooter, CardList, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                transactions: []
            };
        },
        methods: {
            load: function() {
                this.$emit('loading', true);
                http.get('payment-plans/failed-transactions', {force: true}).then(response => {
                    this.transactions = response.data;
                    this.$emit('loading', false);
                }).catch(err => {
                    console.log(err);
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.load();
            }
        },
        mounted() {
            this.load();
        }
    };
</script>
